import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { Injector } from "@angular/core";
import { FuenteDinamicaService } from "src/app/services/shared/fuente-dinamica/fuente-dinamica.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class FuenteDinamicaTelcoService {

  private fuenteDinamicaService: FuenteDinamicaService;
  private localStorageService: LocalStorageService;

  constructor(
    private http: HttpClient,
    injector: Injector,
  ) {
    this.fuenteDinamicaService = injector.get<FuenteDinamicaService>(FuenteDinamicaService);
    this.localStorageService = injector.get<LocalStorageService>(LocalStorageService);
  }

  fillVistaPreviaTelco(adhMatrizCod: string, currentCountry: string, baseUrlfuente: string) {
    let idHashDataTelco = 'TELCO_EXCHANGE_' + adhMatrizCod; // es igual a clave_aporte

    let currentCountryTelco = currentCountry;
    let sourceEndpointTelco = 'CONTRIBUTOR_PAYMENT';
    let baseUrlfuenteTelco = this.fuenteDinamicaService.baseUrlInGFD(baseUrlfuente, sourceEndpointTelco);
    let dominioSubDominioDISGKLMethodTelco = 'AR_EX_TELCO/CONTRIBUTOR_PAYMENT';

    console.log('baseUrlfuenteTelco, currentCountryTelco, sourceEndpointTelco, idHashDataTelco, dominioSubDominioDISGKLMethodTelco');
    console.log(baseUrlfuenteTelco, currentCountryTelco, sourceEndpointTelco, idHashDataTelco, dominioSubDominioDISGKLMethodTelco);
    // cambio para ruta de Microservicios
    let rutaMicroservicioTelco = (environment.MICROSERVICIO.toString().toLowerCase() === "true" && !this.localStorageService.getIsVip)
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
      : "";

    let urlBaseApiTelco = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const urlGklHashTelco = (environment.CONSUME_API_DATA.toString().toLowerCase() === "true")
      ? `${urlBaseApiTelco}${rutaMicroservicioTelco}${baseUrlfuenteTelco}${currentCountryTelco.toUpperCase()}/${dominioSubDominioDISGKLMethodTelco}`
      : `assets/mock/${currentCountryTelco?.toLowerCase()}/preview/DATA_${sourceEndpointTelco}.json`;
    const internalIdHashGklHash = 'matchkey';

    this.localStorageService.setMatchkeySelected = idHashDataTelco;
    const paramGklHash = new HttpParams().set(internalIdHashGklHash, idHashDataTelco + '.'); // revisar si viene IUP o está bien la variable hash
    const objParamsGklHashTelco = {
      headers: this.fuenteDinamicaService.getTokenToHeaders(),
      params: paramGklHash
    };

    let sMatrizVipTelco = {
      'matriz': this.localStorageService.getMatrizArray
    };
    console.log('Telco: urlGklHash, objParamsGklHash, sMatrizVip');
    console.log(urlGklHashTelco, objParamsGklHashTelco, sMatrizVipTelco);
    
    return new Promise((resolve, reject) => {
      this.http.get<any>(
        urlGklHashTelco, objParamsGklHashTelco
      ).subscribe(
        data => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
    // comment vip }
  }

  promiseTelcoService(data: any, letSources: string, adhMatrizCod: string) {
    let listDataTelco = data['payload'][letSources];
    console.log('listData Telco', listDataTelco);
    const sortTelco = listDataTelco.sort((a, b) => {
      return Number.parseInt(b.ult_aporte_fh) - Number.parseInt(a.ult_aporte_fh);
    });
    console.log('sortTelco', sortTelco);

    let ultAporteFhTelco = Number(sortTelco[0]['ult_aporte_fh']);
    this.localStorageService.setUltAporteFh = ultAporteFhTelco;
    console.log('Esto es el listdata Telco', ultAporteFhTelco);

    console.log('ultAporteFhTelco', ultAporteFhTelco);
    // comment let idHashDataAdded = "." + this.localStorageService.getPersonaSelected['iup'] + "." + adhMatrizCod + "." + (ultAporteFhTelco); // "3A6BED07C48043199CD42580C8C46623.75618507.BZ2165.20230801"
    // let idHashDataAdded = "." + this.localStorageService.getPersonaSelected['iup'] + "." + adhMatrizCod; // "3A6BED07C48043199CD42580C8C46623.75618507.BZ2165.20230801"
    let idHashDataAdded = "." + 0 + "." + adhMatrizCod; // "3A6BED07C48043199CD42580C8C46623.75618507.BZ2165.20230801"
    return { ultAporteFhTelco, idHashDataAdded };
  }

}
